var _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftArrowinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Grupo 1059",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 1059"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 446",
    d: "M4.243 15.086l4.328 4.307a.828.828 0 001.168-1.174l-2.905-2.891h17.537a.828.828 0 100-1.656H6.834l2.905-2.891a.828.828 0 00-1.168-1.174l-4.327 4.306a.829.829 0 00-.001 1.173z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rect\\xE1ngulo 418",
    fill: "none",
    d: "M0 0h30v30H0z"
  })));
}

export default SvgLeftArrowinline;